import { useEffect } from "react";

import SiteChrome from "@chrome/SiteChrome";

const CloseTab = () => {
  useEffect(() => {
    window.close();
  });
  return (
    <SiteChrome>Success. This browser tab should close itself soon.</SiteChrome>
  );
};

export default CloseTab;
